import { ApiSmpGptAgent } from "./agent";
import { ApiSmpGptAsk } from "./ask";
import { ApiSmpGptDescribe } from "./describe";
import { ApiSmpGptEdit } from "./edit";
import { ApiSmpGptGenerate } from "./generate";
import { ApiSmpGptPrompt } from "./prompt";
export class ApiSmpGpt {
}
ApiSmpGpt.Agent = ApiSmpGptAgent;
ApiSmpGpt.Ask = ApiSmpGptAsk;
ApiSmpGpt.Prompt = ApiSmpGptPrompt;
ApiSmpGpt.Generate = ApiSmpGptGenerate;
ApiSmpGpt.Describe = ApiSmpGptDescribe;
ApiSmpGpt.Edit = ApiSmpGptEdit;
//# sourceMappingURL=gpt.js.map